import type { QuerySettings } from '@customTypes/index';
import { useQuery } from '@tanstack/react-query';

import type { GetClubProfileHousingRequest } from '@/shared/api/requests/club/housing/get/request';
import { getClubProfileHousing } from '@/shared/api/requests/club/housing/get/request';

export const useClubProfileHousingQuery = (
  params: GetClubProfileHousingRequest,
  settings?: QuerySettings<typeof getClubProfileHousing>
) =>
  useQuery({
    queryKey: ['ClubProfileHousing', params.clubId],
    queryFn: () =>
      getClubProfileHousing({
        params,
        config: settings?.config
      }),
    ...settings?.options
  });
